export class TemporarySession {
    public access_token: string;
    public jwt: string;
    public username: string;
    public firstName: string;
    public lastName: string;
    public country: string;
}
